const SCRIPT_ID = "google-recaptcha"

import getEnv from "./env"

//  Get reCAPTCHA site key
export function getRecaptchaSiteKey() {
	return getEnv("VUE_APP_RECAPTCHA_SITE_KEY") || "6Lfa-v4sAAAAAM3p4dhT8IFhatScwZ8E3hjukZ52"
}

// Check if enabled
export function isRecaptchaEnabled() {
	return !!getRecaptchaSiteKey()
}

// Load Google reCAPTCHA script
export function loadRecaptchaScript() {
	const siteKey = getRecaptchaSiteKey()

	if (!siteKey) {
		return Promise.resolve(null)
	}

	// Already ready
	if (
		window.grecaptcha &&
		typeof window.grecaptcha.render === "function"
	) {
		return Promise.resolve(window.grecaptcha)
	}

	return new Promise((resolve, reject) => {
		// Script already loading
		if (document.getElementById(SCRIPT_ID)) {
			const wait = setInterval(() => {
				if (
					window.grecaptcha &&
					typeof window.grecaptcha.render === "function"
				) {
					clearInterval(wait)

					window.grecaptcha.ready(() => {
						resolve(window.grecaptcha)
					})
				}
			}, 100)

			return
		}

		const script = document.createElement("script")

		script.id = SCRIPT_ID
		script.src =
			"https://www.google.com/recaptcha/api.js?render=explicit"

		script.async = true
		script.defer = true

		script.onload = () => {
			const wait = setInterval(() => {
				if (
					window.grecaptcha &&
					typeof window.grecaptcha.render === "function"
				) {
					clearInterval(wait)

					window.grecaptcha.ready(() => {
						resolve(window.grecaptcha)
					})
				}
			}, 100)
		}

		script.onerror = () => {
			reject(new Error("Could not load Google reCAPTCHA"))
		}

		document.head.appendChild(script)
	})
}

// Render reCAPTCHA widget
export function renderRecaptcha(container, options = {}) {
	return loadRecaptchaScript().then((grecaptcha) => {
		if (!grecaptcha || !container) {
			return null
		}

		return grecaptcha.render(container, {
			sitekey: getRecaptchaSiteKey(),

			theme: options.theme || "light", // "light" | "dark"
			size: options.size || "normal",  // "normal" | "compact" | "invisible"

			callback: options.callback,
			"expired-callback": options["expired-callback"],
			"error-callback": options["error-callback"],
		})
	})
}

// Get token from widget
export function getRecaptchaToken(widgetId) {
	if (!window.grecaptcha) return null
	return window.grecaptcha.getResponse(widgetId)
}

// Reset widget
export function resetRecaptcha(widgetId) {
	if (window.grecaptcha) {
		window.grecaptcha.reset(widgetId)
	}
}

// Extract API error details (unchanged)
export function extractApiErrorDetails(errorPayload) {
	if (!errorPayload) return []

	if (Array.isArray(errorPayload.details)) {
		return errorPayload.details
	}

	if (errorPayload.response?.data?.error?.[0]?.details) {
		return errorPayload.response.data.error[0].details
	}

	return []
}